export function goBack() {
    document.addEventListener( 'DOMContentLoaded', function () {
        let goBack = document.querySelector('.go-back');
        goBack.addEventListener('click', () => {
          history.back();
        });
    })
}